import { Dispatch, SetStateAction, useState } from 'react';
import { FetchStatus } from '../../enums/fetchStatuses';

export const useFetchStatus = (): [FetchStatus, Dispatch<SetStateAction<FetchStatus>>] => {
	const [status, setStatus] = useState(FetchStatus.PENDING);

	return [status, setStatus];
};
